import { Action, Subject } from '@erp/authz';

import { useCan } from '@/hooks/useCan';

/** What the viewer may do to the Results → Upload layouts and rules. */
export function usePricingPermissions() {
  const [canCreate] = useCan(Action.Create, Subject.Pricing);
  const [canUpdate] = useCan(Action.Update, Subject.Pricing);
  const [canDelete] = useCan(Action.Delete, Subject.Pricing);
  return { canCreate, canUpdate, canDelete };
}
